<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >

  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>

  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
            :recognizeName="recognizeName"
          />
        </div>
      </div>
    </div>


    <div style="flex:0 0 15px;" />

    <div class="column bg-white shadow-1 full-width">
      <q-expansion-item icon="camera_alt" :label=cameraLabel class="bg-secondary full-width" default-opened dark expand-icon-class="text-secondary"  :disable="checkPermission == false"
        @show="state.dialogCameraCapture.show = true"
        @hide="state.dialogCameraCapture.show = true">
      </q-expansion-item>
    </div>

    <div style="flex:0 0 15px;" />

    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile" :disable="checkPermission == false">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="settings" label="옵션" dense no-caps @click="state.dialogOptions.show = true" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" :icon="state.useDirectionCls ? 'check_box' : 'check_box_outline_blank'" label="방향판별 사용" dense no-caps @click="state.useDirectionCls = !state.useDirectionCls" style="padding:0px 5px;" />
        </q-btn-group>
        <q-space />
        <q-tabs
          v-model="state.tab"
          indicator-color="primary"
          inline-label
          shrink stretch
        >
          <q-tab name="text" icon="list_alt" label="Text" />
          <q-tab name="json" icon="account_tree" label="Json" />
        </q-tabs>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange" />
        </div>

        <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
          <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
            <q-tab-panel class="full-height column" name="text" style="overflow:hidden;" >
              <div>
                <q-input label="검색..." dense @input.native="listen__text_search__oninput" :value="state.searchText">
                  <template v-slot:prepend>
                    <q-icon name="search"/>
                  </template>
                  <template v-slot:append>
                    <q-icon name="close" @click="state.searchText = ''" class="cursor-pointer" />
                  </template>
                </q-input>
              </div>
              <div v-if="state.searchText != null && state.searchText != ''" class="text-caption text-grey row reverse" style="margin:10px 0px 5px 0px">
                {{ `검색 된 필드: ${searchTexts.length}개 / 검출 된 필드: ${pred.length}개`}}
              </div>
              <div v-else class="text-caption text-grey row reverse" style="margin:10px 0px 5px 0px">
                {{ `검출 된 필드: ${pred.length}개`}}
              </div>
              <div class="col" style="overflow:auto;">
                <template v-for="(field, index) in searchFields">
                  <field-list-item
                    :field="field"
                    :key="`field-${index}`"
                  />
                  <q-separator v-if="index < fields.length - 1" :key="`sep-${index}`" />
                </template>
              </div>
            </q-tab-panel>
            <q-tab-panel name="json">
              <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>

  <camera-capture-dialog v-if="state.dialogCameraCapture.show"
     :resolution="state.dialogCameraCapture.resolution"
    @oncapture="listen__dialogCameraCapture__oncapture"
    @onerror="state.dialogCameraCapture.show = false"
    />

  <q-dialog v-model="state.dialogOptions.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">옵션</div>
      </q-card-section>
      <q-item-label header>문자영역 선 두께</q-item-label>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        신용카드가 포함된 이미지를 입력 받아 카드번호와 유효기간을 출력한다.
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=175440343">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=175440343</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import FieldListItem from '@/projects/document/components/FieldListItem.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'
import CameraCaptureDialog from '@/components/CameraCaptureDialog.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import DocumentOCR from '@/js/document_ocr.js'
import ETC from '@/js/etc.js'
import UserJS from '@/js/user.js'

import _ from 'lodash'
import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {

      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogOptions: {
          show: false
        },
        dialogCameraCapture: {
          show: false,
          resolution: 'vga'
        },
        fitToWindow: false,
        searchText: null,
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        bboxShow: true,
        useDirectionCls: false
      },
      sampleImages: [
        {
          name: '신용카드 1',
          filename: 'CreditCard_001.png',
          url: `${process.env.VUE_APP_URL}/api/image/d6480286-bbf6-413b-bed3-27ae4120a2b0.png`
        },
        {
          name: '신용카드 2',
          filename: 'CreditCard_002.png',
          url: `${process.env.VUE_APP_URL}/api/image/40cdcfef-5839-445d-9ec1-12e4501efb36.png`
        },
        {
          name: '신용카드 3',
          filename: 'CreditCard_003.png',
          url: `${process.env.VUE_APP_URL}/api/image/22ba95d8-5cb3-4955-9170-ebc4566b8b80.png`
        },
        {
          name: '신용카드 4',
          filename: 'CreditCard_004.png',
          url: `${process.env.VUE_APP_URL}/api/image/0a569c23-01c4-43b7-bbd6-3e6ef8385575.png`
        },
        {
          name: '신용카드 5',
          filename: 'CreditCard_005.png',
          url: `${process.env.VUE_APP_URL}/api/image/ef107935-c951-41bf-bb05-5d5e2dc7adec.png`
        },
        {
          name: '신용카드 6',
          filename: 'CreditCard_006.png',
          url: `${process.env.VUE_APP_URL}/api/image/95f7bdf0-b3c6-4745-96d2-115846b9ef67.png`
        }
      ],
      fieldInfo: [
        {
          name: 'cardNumber',
          color: '#e6194b'
        },
        {
          name: 'validDate',
          color: '#3cb44b'
        }
      ],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      fields: [],
      jsonData: [],
      title: "신용카드 인식",
      recognizeName: "credit",
    }
  },
  components: {
    ImageProcessingDialog,
    SampleImageList,
    ImageView,
    FieldListItem,
    HealthCheckWidget,
    CameraCaptureDialog
  },
  methods: {
    listen__x__onfilechange: function (file, options) {
      const Vue = this
      
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let processingTime
        try {
          const begin = new Date();
          ret = await DocumentOCR.recognizeCreditcard(file, Vue.state.useDirectionCls);
          let ret_fields = []
          if (ret.data != undefined) {
            if (ret.data.result != undefined) {
              if (ret.data.result.fields != undefined)
                ret_fields = ret.data.result.fields
            }
          }
          processingTime = (new Date() - begin) / 1000
          let pred = []
          for (let i in ret_fields) {
            let datum = ret_fields[i]
            const idx = Vue.fieldInfo.map(v => v.name).indexOf(datum.name)
            const color = (idx == -1) ? '#000000' : Vue.fieldInfo[idx].color
            
            pred.push({
              id: i, text: datum.value, prob: '',
              key: datum.name,
              active: Vue.state.bboxShow,
              highlight: false,
              color: color,
              points: [
                {x: datum.pts[0][0], y: datum.pts[0][1]},
                {x: datum.pts[1][0], y: datum.pts[1][1]},
                {x: datum.pts[2][0], y: datum.pts[2][1]},
                {x: datum.pts[3][0], y: datum.pts[3][1]},
              ]
            });
          }

          let fields = []
          for (let i in ret_fields) {
            let datum = ret_fields[i]
            const idx = Vue.fieldInfo.map(v => v.name).indexOf(datum.name)
            const color = (idx == -1) ? '#000000' : Vue.fieldInfo[idx].color

            fields.push({
              id: i, color,
              name: datum.name,
              key: datum.name,
              value: datum.value,
              roi: datum.pts
            });
          }
          // fields.sort((a, b) => a.orderY - b.orderY)
          ret.pred = pred
          ret.fields = fields
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        Vue.pred = ret.pred
        Vue.fields = ret.fields
        ret.data['processingTime'] = processingTime
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__btn_bbox__onclick: function () {
      this.state.bboxShow = !this.state.bboxShow;
      
      this.updateTagging()
    },
    listen__dialogCameraCapture__oncapture: function (data) {
      this.state.dialogCameraCapture.resolution = data.resolution
      this.state.dialogCameraCapture.show = false
      if (data.file != undefined) {
        this.listen__x__onfilechange(data.file)
      }
    },
    listen__text_search__oninput: _.debounce(function (e) {
      this.state.searchText = e.target.value
    }, 300),
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
      this.fields = []
    },
    updateTagging() {
      for (let item of this.pred) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = this.state.bboxShow
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = false
          }
        }
      }

      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    healthCheckFunction: DocumentOCR.recognizeCreditcard,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    searchTexts: function () {
      if (this.pred.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.pred.slice();
      } else {
        let searchTexts = [];
        for (let item of this.pred) {
          if (item.key.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    searchFields: function () {
      let searchFields = [];
      for (let item of this.fields) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1)
          searchFields.push(item);
      }
      return searchFields;
    },
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '카메라 권한이 없습니다.' 
    }
  },
  watch: {
    searchTexts: function () {
      this.updateTagging()
    },
    'state.currentFrameToolOption.lineWidth': function (value) {
      this.$refs['image-view1'].setToolOption('lineWidth', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineWidth', value)
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>